// @flow
import type { SignUpDeliveryContactActionType } from './actions';
import type { StateType } from '../../reducers';

export const initialState: DeliveryContactStateType = {
  name: '',
  phoneNumber: '',
};

export default (state: DeliveryContactStateType = initialState, action: SignUpDeliveryContactActionType) => {
  switch (action.type) {
    case 'SIGNUP_SET_DELIVERY_CONTACT':
      const { deliveryContact } = action.payload;
      return {
        ...state,
        ...deliveryContact,
      };

    default:
      return state;
  }
};

export type DeliveryContactStateType = {|
  name: string,
  phoneNumber: string,
|};

export type DeliveryContactType = $Shape<DeliveryContactStateType>;

const deliveryContactStateSelector = (state: StateType): DeliveryContactStateType => state.signUp.deliveryContact;

export const deliveryContactSelector = (state: StateType): ?{| name: string, phoneNumber: string |} => {
  return {
    name: deliveryContactStateSelector(state).name,
    phoneNumber: deliveryContactStateSelector(state).phoneNumber,
  };
};
